import { useMemo } from 'react'
import { useStateHooks } from '../../../../../state'
import { TableName } from '../../../../../tables'
import { Check } from '../../../../administration'
import { WidgetCard } from '../widget-card/widgetCard'
import { KpiCard } from '../kpi-card/kpiCard'
import { RoutePath } from '../../../../../features/routes'
import { isActiveCheck, getNext7DaysRange, formatAmount } from '../../../utils/dashboardUtils'

export const ChecksAlertWidget = () => {
    const { getList } = useStateHooks()

    const { upcomingChecks, totalAmount } = useMemo(() => {
        const allChecks = getList(TableName.CHECKS) as Check[]
        const range = getNext7DaysRange()
        const upcoming = allChecks.filter(
            c => isActiveCheck(c) && c.paymentDate >= range.start && c.paymentDate <= range.end
        )
        const total = upcoming.reduce((sum, c) => sum + c.amount, 0)
        return { upcomingChecks: upcoming, totalAmount: total }
    }, [])

    return (
        <WidgetCard
            title="Cheques próximos a vencer"
            empty={upcomingChecks.length === 0}
            emptyLabel="No vencen cheques en los próximos 7 días"
            linkLabel="Ver cheques"
            linkPath={RoutePath.CHECKS}
        >
            <KpiCard
                value={formatAmount(totalAmount)}
                count={`${upcomingChecks.length} cheque${upcomingChecks.length !== 1 ? 's' : ''}`}
                label="vencen en los próximos 7 días"
            />
        </WidgetCard>
    )
}
